export default "__VITE_ASSET__CNc4jnqz__"